module.exports = __webpack_public_path__ + "img/asistencias.ffbe5f17.svg";